// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"MobileCart-module__iconContainer___8ASSl","cartIcon":"MobileCart-module__cartIcon___Zt34Z","cart_count":"MobileCart-module__cart_count___PJdIT"};